import { FC } from "react";

interface FlagEnglishProps {
  className?: string;
}

const FlagEnglish: FC<FlagEnglishProps> = () => {
  return (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_692_2453)">
        <rect width="24" height="18" rx="3" fill="#1A47B8" />
        <path fillRule="evenodd" clipRule="evenodd" d="M2.55311 0H0V3L21.433 18L24 18V15L2.55311 0Z" fill="white" />
        <path d="M0.851541 0L24 16.2425V18H23.1684L0 1.74067V0H0.851541Z" fill="#F93939" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7143 0H24V3C24 3 9.15406 12.9937 2.28571 18H0V15L21.7143 0Z"
          fill="white"
        />
        <path d="M24 0H23.2249L0 16.2565V18H0.851541L24 1.75382V0Z" fill="#F93939" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.72809 0H15.2919V5.55218H24V12.4442H15.2919V18H8.72809V12.4442H0V5.55218H8.72809V0Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1053 0H13.8947V6.92308H24V11.0769H13.8947V18H10.1053V11.0769H0V6.92308H10.1053V0Z"
          fill="#F93939"
        />
      </g>
      <defs>
        <clipPath id="clip0_692_2453">
          <rect width="24" height="18" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlagEnglish;
